import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { format } from 'date-fns'
import { useHistory } from 'react-router-dom'

import LogoDownloadICS from 'i/download-ics.png'
import LogoDownloadIcon from 'i/icons/download-2.svg'
import LogoGoogle from 'i/google.svg'

import { ProfileSideBar } from '../Book/ProfileSideBar'

import { paymentApi, callApi, eventApi } from 'api'

import { setPro } from 'store/actions'

import * as ics from 'ics'

const BookedPage = (props) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [cancelled, setCancelled] = useState(false)
  const [pro, setPro] = useState(null)
  const data = JSON.parse(localStorage.getItem('info'))
  const isEvent = JSON.parse(localStorage.getItem('isEvent'))
  const history = useHistory()

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    const code = [...searchParams].find(([key]) => key === 'payment_intent')?.[1]

    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }
    if (code) {
      if (isEvent) {
        paymentApi.captureEntry({ token: code, group_call_id: data?.event?.id })
      } else {
        paymentApi.captureOrder({ token: code, call_id: data?.call_id })
      }
    }

    setPro(data?.pro)

    window.addEventListener('resize', handleResize)
  }, [data?.call_id, data?.event?.id, data?.pro, isEvent])

  useEffect(() => {
    document.title = 'TalkPro | Call Booked'
  }, [])

  useEffect(() => {
    props.setIsConfirmPage(true)
    return () => {
      props.setIsConfirmPage(false)
    }
  }, [props])

  const getCancelableInfo = () => {
    if (data?.event?.id) {
      return { type: 'event', id: data.event.id }
    }

    const callId = data?.call_id || data?.callRequest?.id
    if (callId) {
      return { type: 'call', id: callId }
    }

    return null
  }

  const handleCancelBooking = async () => {
    const cancelableInfo = getCancelableInfo()
    if (!cancelableInfo) return false

    if (cancelableInfo.type === 'event') {
      await eventApi.cancelEvent(cancelableInfo.id)
    } else {
      await callApi.cancelCall({ id: cancelableInfo.id })
    }

    return true
  }

  const event = {
    start: data?.event
      ? [
          new Date(data?.event?.scheduled_at).getFullYear(),
          new Date(data?.event?.scheduled_at).getMonth() + 1,
          new Date(data?.event?.scheduled_at).getDate(),
          new Date(data?.event?.scheduled_at).getHours(),
          new Date(data?.event?.scheduled_at).getMinutes(),
        ]
      : [
          new Date(data?.callRequest?.scheduled_at).getFullYear(),
          new Date(data?.callRequest?.scheduled_at).getMonth() + 1,
          new Date(data?.callRequest?.scheduled_at).getDate(),
          new Date(data?.callRequest?.scheduled_at).getHours(),
          new Date(data?.callRequest?.scheduled_at).getMinutes(),
        ],
    duration: { hours: 1, minutes: 0 },
    title: `TALKPRO - Call with ${data?.event?.pro?.user?.name}`,
    description: 'Join TalkPro Classes https://www.talkpro.com/user/login',
    location: 'https://www.talkpro.com/user/login',
    url: 'https://www.talkpro.com/user/login',
    status: 'CONFIRMED',
    busyStatus: 'BUSY',
    geo: { lat: 0, lon: 0 },
    categories: ['TalkPro', 'Classes'],
    attendees: [
      { email: props.user?.user?.email, name: props.user?.user?.name },
      { email: data?.event?.pro?.user?.email, name: data?.event?.pro?.user?.name },
    ],
  }

  const scheduledDate = data?.event
    ? format(new Date(data?.event?.scheduled_at), 'EEEE, LLLL d, yyyy')
    : format(new Date(data?.callRequest?.scheduled_at), 'EEEE, LLLL d, yyyy')

  const scheduledTime = data?.event
    ? format(new Date(data?.event?.scheduled_at), 'h:mma O')
    : format(new Date(data?.callRequest?.scheduled_at), 'h:mma O')

  return (
    <section className="section profile">
      <div className="book__cols">
        <div className="book__col book__col--sidebar book__col--mobile_hidden_mod">
          <ProfileSideBar profile={pro} windowWidth={windowWidth} />
        </div>
        <div className="book__col book__col--main">
          <div className="book__col_content">
            <div className="profile_calendar">
              <div className="signup__col_in">
                <div className="signup__info">
                  <h1 className="signup__title signup__title--lg_mod">
                    {cancelled ? 'Call cancelled' : "You're booked!"}
                  </h1>
                  <div className="signup__descr">
                    You have received an email with a confirmation of your talk.
                  </div>
                  <ul className="signup__descr_list">
                    <li className="signup_descr_list_item">{scheduledDate} </li>
                    <li className="signup_descr_list_item">{scheduledTime}</li>
                    <li className="signup_descr_list_item">30 Minute talk</li>
                  </ul>
                </div>

                {!cancelled && (
                  <div className="signup__tabs">
                    <div className="signup__tabs_content">
                      <div className="signup__tabs_content_item signup__tabs_content_item--active">
                        <div className="signup__form">
                          {localStorage.getItem('login-method') === 'apple' && (
                            <div className="form_group">
                              <button
                                type="submit"
                                className="form_group__button form_group__button--icon_mod form_group__button--blue_mod"
                                onClick={(e) => {
                                  ics.createEvent(event, (error, value) => {
                                    if (error) {
                                      console.log(error)
                                    } else {
                                      const blob = new Blob([value], {
                                        type: 'text/calendar',
                                      })
                                      const url = URL.createObjectURL(blob)
                                      const a = document.createElement('a')
                                      a.href = url
                                      a.download = 'event.ics'
                                      a.click()
                                      URL.revokeObjectURL(url)
                                    }
                                  })
                                }}
                              >
                                <span className="form_group__button_img">
                                  <img
                                    className="form_group__button_img_in"
                                    src={LogoDownloadICS}
                                    alt="Download ICS"
                                  ></img>
                                </span>
                                Add to your Calendar
                              </button>
                            </div>
                          )}

                          <div className="form_group">
                            <button
                              type="submit"
                              className="form_group__button form_group__button--icon_2_mod form_group__button--blue_mod"
                              onClick={(e) => {
                                ics.createEvent(event, (error, value) => {
                                  if (error) {
                                    console.log(error)
                                  } else {
                                    const blob = new Blob([value], {
                                      type: 'text/calendar',
                                    })
                                    const url = URL.createObjectURL(blob)
                                    const a = document.createElement('a')
                                    a.href = url
                                    a.download = 'event.ics'
                                    a.click()
                                    URL.revokeObjectURL(url)
                                  }
                                })
                              }}
                            >
                              <span className="form_group__button_img form_group__button_img--v2_mod form_group__button_img--size_mod">
                                <img
                                  className="form_group__button_img_in"
                                  src={LogoDownloadIcon}
                                  alt="Google icon"
                                />
                              </span>
                              Add to your Calendar
                            </button>
                          </div>
                          <div className="form_group">
                            <button
                              type="button"
                              className="form_group__button form_group__button--icon_2_mod form_group__button--added_google_mod"
                            >
                              <span className="form_group__button_img form_group__button_img--v2_mod form_group__button_img--google_mod">
                                <img
                                  className="form_group__button_img_in"
                                  src={LogoGoogle}
                                  alt="Google icon"
                                />
                              </span>
                              Added to Google Calendar
                            </button>
                          </div>
                          <div className="form_group">
                            <div className="form_group__descr">
                              Need to make a change?{' '}
                              <a
                                href="/"
                                onClick={async (e) => {
                                  e.preventDefault()
                                  const isCancelled = await handleCancelBooking()
                                  if (isCancelled) {
                                    history.push(`/${data.pro?.channel_name}`)
                                  }
                                }}
                              >
                                Reschedule
                              </a>{' '}
                              or{' '}
                              <a
                                href="/"
                                onClick={async (e) => {
                                  e.preventDefault()
                                  const isCancelled = await handleCancelBooking()
                                  if (isCancelled) {
                                    setCancelled(true)
                                  }
                                }}
                              >
                                Cancel
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

const mapStateToProps = ({ auth: { user, error, attributes } }) => ({
  user,
  authError: error,
  attributes,
})

const willMapDispatchToProps = {
  setPro,
}

export default connect(mapStateToProps, willMapDispatchToProps)(BookedPage)
